import { AssetCommentAttachmentService as OvermapAssetCommentAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetCommentAttachmentService extends OvermapAssetCommentAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
